<template>
    <a-modal v-model:open="open" title="用户登录失败" @ok="close" :confirm-loading="loading">
        <p> 登录失败: {{ error.msg }} </p>
        <p> 点击确定确定 关闭窗口 </p>
    </a-modal>
</template>

<script>
import { login } from './api';
import { getUserLoginInfo } from '@/api/login'

export default {
    data() {
        return {
            open: false,
            error: null
        }
    },
    created() {
        console.log('单点登录: ', this.$route);
        // 单点登录
        const query = this.$route.query;
        const ticket = query.ticket;
        const token = getLocalData.getItem('token');

        // 单点登录
        if (ticket) {
            this.autoLogin(ticket);
        } else if (token) {
            this.toMain();
        } else {
            this.jumpLogin();
        }
    },
    methods: {
        jumpLogin() {
            const origin = window.location.origin;
            if (origin.indexOf('local') > -1) {
                // 本地测试
                window.location.href = '/#/login';
            } else if (origin.indexOf('81.70.91.80') > -1) {
                // 本地测试
                window.location.href = '/#/login';
            } else {
                // 其他环境
                const host = window.location.origin;
                window.location.href = `${host}/cnbm-portal-view/#/workbench`;
            }
        },

        autoLogin(ticket) {
            this.loading = true;
            login(ticket).then(res => {
                this.loading = false;
                this.loginSuccess(res);
            }).catch(error => {
                this.error = error;
                this.loading = false;
                console.error(error);
                this.open = true;
            });
        },

        close() {
            window.document.close();
            window.focus();
            window.close();
        },

        toMain() {
            this.$router.push('main')
        },
        toBatch() {
            this.$router.push('/temp/zjc-gongyingshanggongzuotai');
        },
        loginSuccess(data) {
            if (data && data.access_token) {
                // 如果有存储跳转地址 那么跳转到指定地址
                const fullPath = getLocalData.getItem('fullPath');

                // 登陆成功
                // this.$message.success('登录成功!')
                getLocalData.clear() // 清空缓存
                this.$store.commit('clearPage');

                console.log('token:', data.access_token)
                getLocalData.setItem('token', data.access_token)

                getUserLoginInfo({}).then((infodata) => {
                    if (infodata) {
                        this.loading = false
                        // this.$message.success('登录成功!')
                        if (infodata.companys && infodata.companys.length > 0) {
                            getLocalData.setItem('companyInfo', JSON.stringify(infodata.companys[0]))
                        }

                        console.log('userdata.data:', infodata.user)
                        getLocalData.setItem('userInfo', JSON.stringify(infodata.user))
                        getLocalData.setItem('role', JSON.stringify(infodata.roles[0]))

                        console.log('menudata.data:', infodata.menus)
                        getLocalData.setItem('menuList', JSON.stringify(infodata.menus) || []);

                        this.authFormat(infodata.menus);

                        if (fullPath) {
                            // 跳转地址 不能包含令牌 否则还会跳转到自动登录
                            const reg = /ticket=[^&]*/;
                            const newurl = fullPath.replace(reg, '');
                            getLocalData.setItem('fullPath', '');
                            this.$router.push(newurl);
                        } else {
                            if (infodata.user.tenantType === '1') {
                                this.toBatch();
                            } else {
                                this.toMain()
                            }
                        }
                    }
                }).catch((error) => {
                    this.loading = false
                    console.error(error);
                })
            } else {
                //
            }
        },

        /** 保存权限 字典 */
        authFormat(menuList = null) {
            if (menuList) {
                const authmap = {}
                menuList.forEach((element) => {
                    const path = element.url
                    const auth = element.auth
                    if (auth) {
                        const auths = auth.split(',').map((item) => {
                            const items = item.split(':')
                            if (items?.length === 3) {
                                return items[1]
                            }
                            return null
                        })
                        authmap[path] = auths
                    }
                })
                getLocalData.setItem('auth', JSON.stringify(authmap))
            }
        },
    },
}
</script>

<style lang="scss" scoped>
.box {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
}
</style>